import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Box, Button, FormField, Link, Pagination, Select, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiFileExcel, mdiFilterMenuOutline, mdiFilterMultiple, mdiHumanMaleBoard, mdiMagnify, mdiTowTruck } from '@mdi/js';
import Icon from '@mdi/react';
import DRPicker from '../../../../../components/DRPicker';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelFlight from '../../../../../components/extras/SidePanelFlight';
import SelectCategory from '../../../../../components/selects/selectCategory';
import SelectEquipments from '../../../../../components/selects/selectEquipments';
import SelectFlightType from '../../../../../components/selects/selectFlightTypes';
import SelectGroupType from '../../../../../components/selects/selectGroupType';
import SelectPaging from '../../../../../components/selects/selectPaging';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemFlight, ItemUser, pilotTypes } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, exportToExcel, getCookie, getUrlVersion, minutes2Hours, minutesToHHMM2, setData, setLoading, setParameters } from '../../../../commons/functions';

export const OPSFlightSearchPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")


    const { navigate } = useRouter();
    const { data, parameters, menu } = useGlobalState();
    const [flights, setFlights] = useState<ItemFlight[]>([]);
    const [flight, setFlight] = useState<ItemFlight>();
    const [userCount, setUserCount] = useState<number>(0);
    const [advanceFilter, setAdvanceFilter] = useState<boolean>(false);
    const [currentPageIndex, setCurrentPageIndex] = useState(1);

    const paginated = flights.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);

    useEffect(() => {
        if (parameters.startDate && parameters.endDate && parameters.pilotType && parameters.groupTypeMasterCode) {
            //handleFlightsSearch()
        }
    }, [parameters.startDate, parameters.endDate, parameters.pilotType, parameters.groupTypeMasterCode, parameters.idCategories, parameters.idGroupTypes, parameters.idFlightTypes, parameters.idUser]);

    const handleExcel = () => {
        let cumulativeDelta = 0;

        const flightsData = flights.map(flight => {
            cumulativeDelta += flight.delta ?? 0;
            return {
                Fecha: flight.departureDate,
                Material: flight.groupTypeMaster,
                Matrícula: flight.registration,
                Piloto: flight.userPilot,
                Instructor: flight.userInstructor || '',
                Tipo: flight.flightType,
                Duración: minutesToHHMM2(flight.delta ?? 0),
                Acumulado: minutesToHHMM2(cumulativeDelta),
            };
        });
        exportToExcel(flightsData, `bitacora_vuelos_${parameters.startDate}_a_${parameters.endDate}.xlsx`);
    }
    const handleFlightsSearch = async () => {
        //console.log("handleFlightsSearch")
        try {
            setLoading(true)
            let body: any = {
                startDate: parameters.startDate,
                endDate: parameters.endDate,
                pilotType: parameters.pilotType ? parameters.pilotType : '',
                orderBy: "departureDate",
                order: "desc",
            }
            if (parameters.groupTypeMasterCode && parameters.groupTypeMasterCode.value != '') {
                //body = { ...body, groupTypeMasterCode: parameters.groupTypeMasterCode.value }
            }
            if (parameters.idUser && parameters.idUser > 0) {
                body = { ...body, idUser: parameters.idUser }
            }
            if (parameters.idCategories && parameters.idCategories.length > 0) {
                body = { ...body, idCategories: parameters.idCategories }
            }
            if (parameters.idGroupTypes && parameters.idGroupTypes.length > 0) {
                body = { ...body, idGroupTypes: parameters.idGroupTypes }
            }
            if (parameters.idFlightTypes && parameters.idFlightTypes.length > 0) {
                body = { ...body, idFlightTypes: parameters.idFlightTypes }
            }
            if (parameters.idEquipments && parameters.idEquipments.length > 0) {
                body = { ...body, idEquipments: parameters.idEquipments }
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                //console.log("Vuelos obtenidos:", data.flights);
                setFlights(data.flights);
                setFlight(undefined)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            console.error("Error de red y/o comunicaciones:", error);
        } finally { setLoading(false) }
    }
    const totalFilters = parameters.idCategories?.length + parameters.idGroupTypes?.length + parameters.idFlightTypes?.length;

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            splitPanel={
                <SidePanelFlight flight={flight} />
            }
            splitPanelOpen={!!flight}
            onSplitPanelToggle={({ detail }) => !detail.open ? setFlight(undefined) : null}
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Bitácora de vuelos</Header>
                    <Table
                        pagination={

                            <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                {flights.length > parameters.pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(flights.length / parameters.pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )}

                                {flights.length > 0 && flights.length > parameters.pageSize && (
                                    <SelectPaging onSelect={(pageSize) => {
                                        setCurrentPageIndex(1);
                                        setParameters({ ...parameters, pageSize: pageSize });
                                    }} />
                                )}
                            </SpaceBetween>
                        }
                        filter={
                            <SpaceBetween direction="horizontal" size="xs">
                                <Box textAlign='left'>
                                    <SpaceBetween direction="vertical" size="xs">
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <FormField label="Usuario">
                                                <SelectUser onConfirm={(user: ItemUser | undefined) => {
                                                    if (user)
                                                        setParameters({ ...parameters, idUser: user.idUser });
                                                    else
                                                        setParameters({ ...parameters, idUser: 0 });
                                                }}
                                                    value={parameters.idUser}
                                                />
                                            </FormField>

                                            <FormField label="Al mando">
                                                <Select
                                                    selectedOption={pilotTypes.find(pt => pt.value === parameters.pilotType) || { value: 'PILOT', label: 'Piloto' }}
                                                    onChange={(e) => {
                                                        setParameters({ ...parameters, pilotType: e.detail.selectedOption.value });
                                                    }}
                                                    options={pilotTypes}
                                                />
                                            </FormField>
                                            <FormField label="Rango de fechas">
                                                <DRPicker
                                                    start={parameters.startDate || ''}
                                                    end={parameters.endDate || ''}

                                                    onConfirm={(start: string, end: string) => {
                                                        setParameters({ ...parameters, startDate: start, endDate: end });

                                                    }}
                                                />
                                            </FormField>
                                            <FormField label="&nbsp;">
                                                <Button style={{ root: btnIconForm }} onClick={() => setAdvanceFilter(!advanceFilter)}>
                                                    <SpaceBetween direction="horizontal" size="xs">
                                                        {advanceFilter ? <Icon path={mdiFilterMultiple} size={1} /> : <Icon path={mdiFilterMenuOutline} size={1} />}
                                                        {totalFilters > 0 ? totalFilters : null}
                                                    </SpaceBetween>
                                                </Button>
                                            </FormField>
                                            <FormField label="&nbsp;">
                                                <SpaceBetween direction="horizontal" size="xs">

                                                    <Button style={{ root: btnIconForm }} onClick={() => handleFlightsSearch()}><Icon path={mdiMagnify} size={1} /></Button>
                                                    <Button style={{ root: btnIconForm }} disabled={flights.length === 0} onClick={() => handleExcel()}><Icon path={mdiFileExcel} size={1} /></Button>
                                                </SpaceBetween>
                                            </FormField>

                                        </SpaceBetween>
                                        {advanceFilter && (
                                            <SpaceBetween direction="vertical" size="xs">
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    <FormField label="Categoría">
                                                        <SelectCategory single={false} onSelect={(idCategories) => {
                                                            setParameters({ ...parameters, idCategories: idCategories });
                                                        }} value={parameters.idCategories} hideTokens={false} tokenLimit={0}
                                                        />
                                                    </FormField>

                                                    <FormField label="Grupo">
                                                        <SelectGroupType single={false} onSelect={(idGroupTypes) => {
                                                            setParameters({ ...parameters, idGroupTypes: idGroupTypes });
                                                        }} value={parameters.idGroupTypes} hideTokens={false} tokenLimit={0}
                                                        />
                                                    </FormField>
                                                    <FormField label="Tipo de vuelo">
                                                        <SelectFlightType single={false} onSelect={(idFlightTypes) => {
                                                            setParameters({ ...parameters, idFlightTypes: idFlightTypes });
                                                        }} value={parameters.idFlightTypes} hideTokens={false} tokenLimit={0}
                                                            dataset={data.bookingTypes}
                                                        />
                                                    </FormField>
                                                    <FormField label="Materia(es)">

                                                        <SelectEquipments isClub={1} value={parameters?.idEquipments || []}
                                                            onConfirm={(detail) => {
                                                                //console.log(detail)
                                                                setParameters({ ...parameters, idEquipments: detail });
                                                            }}
                                                        />
                                                    </FormField>
                                                </SpaceBetween>
                                            </SpaceBetween>
                                        )}
                                    </SpaceBetween>
                                </Box>
                            </SpaceBetween >
                        }
                        items={paginated}
                        stickyHeader
                        cellVerticalAlign='top'
                        variant='embedded'
                        empty={
                            < Box textAlign="center" color="inherit" >
                                <b>No hay vuelos que mostrar</b>
                                <Box padding={{ top: 's' }} variant="p" color="inherit">
                                    Ajusta los filtros para ver los vuelos registrados.
                                </Box>
                            </Box >
                        }
                        footer=
                        {
                            flights.length > 0 && (<SpaceBetween direction="horizontal" size="xs">
                                <div>
                                    Número de vuelos: <strong>{flights.length}</strong>
                                </div>
                                <div>
                                    Tiempo total: <strong>{flights.reduce((acc, flight) => acc + (flight.delta ?? 0), 0) ? minutesToHHMM2(flights.reduce((acc, flight) => acc + (flight.delta ?? 0), 0)) : '00:00'}</strong>
                                </div>
                            </SpaceBetween>)
                        } columnDefinitions={
                            [
                                {
                                    id: 'id',
                                    header: 'ID/Fecha',
                                    cell: (item) => <FormField label={
                                        <Link onClick={() => {
                                            setFlight(item)
                                        }}>{item.idFlight}</Link>
                                    }>{item.departureDate}
                                    </FormField>,
                                    maxWidth: 100,
                                },
                                {
                                    id: 'duration',
                                    header: 'TPO',
                                    cell: (item) => <FormField label={minutesToHHMM2(item.delta ?? 0)}>{minutes2Hours(item.delta)} h</FormField>,
                                    width: 100,
                                },
                                {
                                    id: 'aircraft',
                                    header: 'Material',
                                    cell: (item) => (
                                        // 🔑 FIX 2: Add key to the outermost component in the cell
                                        <FormField key={`aircraft-formfield-${item.idFlight}`} label={item.registration}>
                                            {item.groupTypeMaster} {item.idTowingTo && item.idTowingTo > 0 ? <Icon path={mdiTowTruck} size={1} /> : ''}
                                        </FormField>
                                    ),
                                    maxWidth: 80,
                                },
                                {
                                    id: 'departure',
                                    header: 'Tripulación',
                                    cell: (item) => (
                                        <FormField label={item.userPilot} key={`labelinstructor-${item.idFlight}`}>
                                            {item.idUserInstructor && item.idUserInstructor > 0 ? (
                                                <SpaceBetween direction="horizontal" size="xs" key={`instructor-spacebetween-${item.idFlight}`}>
                                                    {/* 🔑 FIX 1: Add keys to the children of SpaceBetween */}
                                                    <Icon path={mdiHumanMaleBoard} size={1} key={`icon-${item.idFlight}`} />
                                                    <span key={`instructor-name-${item.idFlight}`}>{item.userInstructor}</span>
                                                </SpaceBetween>
                                            ) : (
                                                // Always return a valid React element or null/'' if conditionally rendering
                                                ''
                                            )}
                                        </FormField>
                                    ),
                                },
                                {
                                    id: 'flightType',
                                    header: 'Tipo',
                                    cell: (item) => item.flightType,
                                    maxWidth: 100
                                },
                            ]}

                    />

                </SpaceBetween >
            }
        />
    )
};

